import { Person } from "./Person";

/**
 * UserInvite interface represents the data structure returned when a 
 * user is invited to join the system
 */
export interface UserInviteInterface {
    id: number;
    signupGuid: string;
    applicationGuid: string | null;
    userInvited: number; // 1 for invited, 0 for not invited
    firstName: string;
    lastName: string;
    email: string;
    companyId: number;
    groupName: string;
}

/**
 * Mapper class to convert UserInviteInterface to other related models
 */
export class UserInviteMapper {
    /**
     * Maps UserInviteInterface to a Person object
     */
    public static toPerson(invite: UserInviteInterface): Person {
        return new Person(
            invite.id.toString(),
            invite.firstName,
            invite.lastName,
            invite.email,
            invite.groupName,
            null, // lastActiveDate is not available in UserInviteInterface
            'pending' // New invites are considered 'pending'
        );
    }
}